export const prices=[
    {
        value:1500
    },
    {
        value:2000
    },
    {
        value:5000
    },
    {
        value:1000
    },
]

export const rooms=[
    {
        value : 'Room with sofa'
    } , 
    {
        value : 'Room with table & chair'
    } , {
        value : 'Room with kitchen'
    } , {
        value : 'Room with hall'
    } , {
        value : 'Room with hall,kitchen,table & chair'
    }
]